import { instanceApiAuth } from "../../src/utils/apiProtheus";


export const vendedorAPI = {
  getVendedor: async (cod, cpf) =>
    (await instanceApiAuth("03,01")).get(`/all/restVendedorAppComercial/v1/info?cod=${cod}&cpf=${cpf}`)

};
